<template>
  <div>
    <div class="pt-2"></div>
    <div class="text-right">
      <b-button variant="primary" v-b-toggle.sidebar-posts>Add Post</b-button>
    </div>
    
    <div class="pt-3">
      <PostTable />
    </div>

    <b-sidebar id="sidebar-posts" shadow right backdrop>
      <AddPost />
    </b-sidebar>
  </div>
</template>

<script>
import PostTable from "./Components/PostTable.vue";
import AddPost from "./Components/AddPost.vue";
import { BButton, BSidebar } from "bootstrap-vue";

export default {
  name: "Posts",
  components: {
    PostTable,
    AddPost,
    BButton,
    BSidebar,
  },
};
</script>